import * as React from 'react';
import * as classNames from 'classnames';
import './styles.sass';

interface IJobsCharacterCounterProps {
  textLength: number;
  maxLength: number;
}

const PREFIX = 'jobs-character-counter';

export const JobsCharacterCounter: React.StatelessComponent<IJobsCharacterCounterProps> = ({
  textLength, maxLength,
}) => (
  <div className={PREFIX}>
    <span className={classNames({
      [`${PREFIX}_grey`]: textLength === 0,
      [`${PREFIX}_genoa`]: textLength > 0 && textLength <= maxLength,
      [`${PREFIX}_red`]: textLength > maxLength,
    })}>
      {textLength}
    </span>
    <span className={`${PREFIX}_grey`}>/{maxLength}</span>
  </div>
);
